import request from '@/utils/request'


export function getalllist() {
  return request({
    url: '/app/index/getalllist',
    method: 'post',
  })
}

export function getSiteBaseInfo() {
  return request({
    url: '/app/index/getbaseinfo',
    method: 'post',
  })
}

export function getNoticeAndPolicyList(data) {
  return request({
    url: '/app/article/index',
    method: 'post',
    data
  })
}
export function getNoticeAndPolicyDetail(data) {
  return request({
    url: '/app/article/info',
    method: 'post',
    data
  })
}

export function getuserinfo() {
  return request({
    url: '/app/index/getuserinfo',
    method: 'post'
  })
}

